import React, { Component } from 'react';
import Notifier from '../../../services/Notifier';

import regimage01 from '../../../assets/images/register_img01.png';
import regimage03 from '../../../assets/images/register_img03.png';
import care from '../../../assets/images/care.png';
import gradeimg from '../../../assets/images/grade.png';
import workingimg from '../../../assets/images/working-rights.png';

class ClientFormLayout extends Component {
  state = {
    formOne: 'active',
    formTwo: '',
    formThree: '',
    formFour: '',
  };

  componentDidMount() {
    this.listner = Notifier.listen(this.onChangeForm);
    const uri = window.location.pathname.split('/').pop();
    console.log('uri', uri);
    switch (uri) {
      case 'form1':
        this.onChangeForm({ type: 'form-change', form: 1 });
        break;
      case 'summary':
        this.onChangeForm({ type: 'form-change', form: 2 });
        break;
      case 'complete':
        this.onChangeForm({ type: 'form-change', form: 3 });
        break;
    }
  }

  componentWillUnmount() {
    if (this.listner) {
      this.listner.unsubscribe();
    }
  }

  onChangeForm = (data) => {
    if (data.type != 'form-change') return;
    switch (data.form) {
      case 1:
        this.setState({
          formOne: 'active',
          formTwo: '',
          formThree: '',
          formFour: '',
        });
        break;
      case 2:
        this.setState({
          formOne: 'active',
          formTwo: 'active',
          formThree: '',
          formFour: '',
        });
        break;
      case 3:
        this.setState({
          formOne: 'active',
          formTwo: 'active',
          formThree: 'active',
          formFour: '',
        });
        break;
      case 4:
        this.setState({
          formOne: 'active',
          formTwo: 'active',
          formThree: 'active',
          formFour: 'active',
        });
        break;
    }
  };

  render() {
    return (
      <section id="council-registration" className="innerpage_bg">
        <div className="container">
          <div className="council-registration_wrapper individual-registration">
            <h4 className="cc-main_title--md">Client Detail Form </h4>
            <div className="form-progress">
              <ul className="progress-list">
                <li className={this.state.formOne}>
                  <span>
                    <img
                      src={regimage01}
                      alt="registration progress image"
                      className="progress-img"
                    />
                  </span>
                  <h4 className="progress-title">Company Details</h4>
                </li>
                <li className={this.state.formTwo}>
                  <span>
                    <img
                      src={gradeimg}
                      alt="registration progress image"
                      className="progress-img"
                    />
                  </span>
                  <h4 className="progress-title">Summary</h4>
                </li>
                <li className={this.state.formThree}>
                  <span>
                    <img
                      src={regimage03}
                      alt="registration progress image"
                      className="progress-img"
                    />
                  </span>
                  <h4 className="progress-title">Complete</h4>
                </li>
              </ul>
            </div>
            {this.props.children}
          </div>
        </div>
      </section>
    );
  }
}

export default ClientFormLayout;
